import styled from "@emotion/styled";
import { Typography, Form, InputNumber } from "antd";
import { FC, useEffect, useMemo, useState } from "react";

interface VariationPriceFormProps {
  data: VariationPrice;
  onSetValidate: (value: boolean) => void;
  onSkuPriceChange: (value: VariationPrice) => void;
  prices:PricesInput
}

const VariationPriceForm: FC<VariationPriceFormProps> = ({
  data,
  onSetValidate,
  onSkuPriceChange,
}) => {
  const [skuPrice, setSkuPrice] = useState<VariationPrice>(data);

  const [form] = Form.useForm();

  form.setFieldsValue({
    variant_1_item_id: data.variant_1_item_id,
    variant_2_item_id: data.variant_2_item_id,
  });

  const onChngeFactoryPrice = (e: any) => {
    const factoryPrice = Number(e) || 0;

    setSkuPrice({
      ...skuPrice,
      factory_price: factoryPrice,
    });
  };

  const onChngeWholesalePrice = (e: any) => {
    const wholesalePrice = Number(e) || 0;

    setSkuPrice({
      ...skuPrice,
      wholesale_price: wholesalePrice,
    });
  };

  const onChngeRetailPrice = (e: any) => {
    const retailPrice = Number(e) || 0;

    setSkuPrice({
      ...skuPrice,
      retail_price: retailPrice,
    });
  };

  useMemo(() => {
    onSkuPriceChange(skuPrice);
  }, [skuPrice]);

  // if validate is true, set validate to false
  useEffect(() => {
    if (skuPrice.factory_price > 0 && skuPrice.retail_price > 0 && skuPrice.wholesale_price > 0) {
      onSetValidate(true);
    } else {
      onSetValidate(false);
    }
  }, [skuPrice]);



  return (
    <Form form={form}>
      <WrapperCard>
        <Typography.Text style={{ fontWeight: 400 }}>
          ตัวเลือก: {data.name}
        </Typography.Text>
        <WrapperForm>
          <Form.Item
            label="ราคาตัวแทน"
            name="factory_price"
            style={{ width: "100%" }}
            initialValue={data.factory_price}
            rules={[
              {
                required: true,
                message: "กรุณากรอกราคาตัวแทน",
              },
            ] }
          >
            <InputNumber
              style={{ width: "100%" }}
              onChange={onChngeFactoryPrice}
            />
          </Form.Item>

          <Form.Item
            label="ราคาแพ็กเกจ"
            name="wholesale_price"
            initialValue={data.wholesale_price}
            rules={[
              {
                required: true,
                message: "กรุณากรอกราคาแพ็กเกจ",
              },
            ]}
          >
            <InputNumber
              style={{ width: "100%" }}
              onChange={onChngeWholesalePrice}
            />
          </Form.Item>

          <Form.Item
            label="ราคาปกติ"
            name="retail_price"
            initialValue={data.retail_price}
            rules={[
              {
                required: true,
                message: "กรุณากรอกราคาปกติ",
              },
            ]}
          >
            <InputNumber
              style={{ width: "100%" }}
              onChange={onChngeRetailPrice}
            />
          </Form.Item>
        </WrapperForm>
      </WrapperCard>
    </Form>
  );
};

export default VariationPriceForm;

const WrapperCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  width: 100%;
  padding: 16px;
  border-radius: 4px;
  border: 1px solid #e8e8e8;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.07);
`;

const WrapperForm = styled.div`
  margin-top: 16px;
  width: 100%;
`;
